import { PublicKey } from './PublicKey';
import { JSONSerializable } from '../util/json';

export class StdSignature extends JSONSerializable<StdSignature.Data> {
  constructor(public signature: string, public pub_key: PublicKey) {
    super();
  }

  public static fromData(data: StdSignature.Data): StdSignature {
    const { signature, pub_key } = data;
    return new StdSignature(signature, PublicKey.fromData(pub_key));
  }

  public toData(): StdSignature.Data {
    const { signature, pub_key } = this;
    return {
      signature,
      pub_key: pub_key.toData(),
    };
  }
}
export namespace StdSignature {
  export interface Data {
    signature: string;
    pub_key: PublicKey.Data;
  }
}
